'use strict';

var q = require('q');
var _ = require('lodash');

var tryAgain = function(tryFunction, args, options) {
  options = options || {};
  var retries = options.retries || 3;
  var deferred = q.defer();

  var onFail = function(responseWrapper) {
    var httpErr = _.get(responseWrapper, 'response.xhr.status', null) || _.get(responseWrapper,'response.status', null);

    if (httpErr > 499 && httpErr < 600 && retries-- > 0) {
      tryFunction(args).done((res) => deferred.resolve(res), onFail);
    } else {
      deferred.reject(responseWrapper);
    }
  };

  tryFunction(args).done((res) => deferred.resolve(res), onFail);

  return deferred.promise;
};

module.exports = tryAgain;
